import { useSyncExternalStore } from "react";
import { cardsStore } from "./CardsStore";

export const useCardstore = () => {
  const state = useSyncExternalStore(cardsStore.subscribe, () => cardsStore.state);
  return state;
};
